import { render, staticRenderFns } from "./deposit-sale-stat-list.vue?vue&type=template&id=36a6d708&scoped=true"
import script from "./deposit-sale-stat-list.vue?vue&type=script&lang=js"
export * from "./deposit-sale-stat-list.vue?vue&type=script&lang=js"
import style0 from "./deposit-sale-stat-list.vue?vue&type=style&index=0&id=36a6d708&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a6d708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a6d708')) {
      api.createRecord('36a6d708', component.options)
    } else {
      api.reload('36a6d708', component.options)
    }
    module.hot.accept("./deposit-sale-stat-list.vue?vue&type=template&id=36a6d708&scoped=true", function () {
      api.rerender('36a6d708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/sale-management/sale-stat/deposit-sale-stat-list.vue"
export default component.exports